module.exports = __webpack_public_path__ + "img/02—01—01—IP settings.887f4b51.jpg";